export default "__VITE_ASSET__ENY2SPHi__"